const localFonts = [
    'Apple SD Gothic Neo',
    'Arial',
    'Calibri',
    'Verdana',
    'Helvetica',
    'Tahoma',
    'Trebuchet MS',
    'Times New Roman',
    'Georgia',
    'Garamond',
    'Courier New',
    'Brush Script MT',
];
/**
 * Determines if a font is a local font.
 */
export const isLocalFont = (fontFace) => Boolean(localFonts.find((localFontFace) => localFontFace.toLowerCase() === fontFace.toLowerCase()));
